// Content-first AppBar layout render helper (lint split).
import { AppBar, Toolbar, Box } from '@mui/material';
import {
  renderAppBarAccountMenu,
  renderAppBarLogo,
  renderAppBarQuickFilterRow,
} from '@/components/layout/appBarHeaderShared';
import { AppBarNav } from '@/components/layout/appBarHeaderNavMenu';

export function renderContentFirstAppBar({
  isDesktop,
  tab,
  visiblePages,
  onTabChange,
  t,
  logoAlt,
  initials,
  avatarAnchor,
  setAvatarAnchor,
  onLogout,
  onOpenHelp,
  onOpenSettings,
  accountMenuTriggerRef,
  helpLabel,
  hideQuickFilters = false,
}) {
  const accountMenuLabel = t('appbar.accountMenu', 'Account menu');
  const settingsLabel = t('settings.menuItem', 'Settings');
  const logoutLabel = t('appbar.logout');
  const feedbackLabel = t('appbar.feedback');

  return (
    <AppBar
      position="sticky"
      color="inherit"
      elevation={0}
      sx={{ borderBottom: 1, borderColor: 'divider' }}
    >
      <Toolbar
        variant="dense"
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr auto',
          gridTemplateRows: hideQuickFilters ? 'auto' : 'auto auto',
          gridTemplateAreas: hideQuickFilters
            ? `"logo tabs account"`
            : `
                  "logo tabs account"
                  "quick quick quick"
                `,
          gap: 1.5,
          alignItems: 'center',
          px: 2,
          py: 1.25,
        }}
      >
        {renderAppBarLogo(logoAlt, { gridArea: 'logo' })}
        {!hideQuickFilters
          ? renderAppBarQuickFilterRow({ gridArea: 'quick' })
          : null}
        <AppBarNav
          isDesktop={isDesktop}
          tab={tab}
          visiblePages={visiblePages}
          onTabChange={onTabChange}
          t={t}
          sx={{ gridArea: 'tabs' }}
        />
        <Box
          sx={{
            gridArea: 'account',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          {renderAppBarAccountMenu({
            initials,
            avatarAnchor,
            setAvatarAnchor,
            onLogout,
            onOpenHelp,
            onOpenSettings,
            accountMenuTriggerRef,
            accountMenuLabel,
            settingsLabel,
            helpLabel,
            logoutLabel,
            feedbackLabel,
          })}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
